



































































































import Vue from "vue";
import { Header } from "@/components/MyTable.vue";
import { ListHeader } from "@/components/MyListCard.vue";
import { axios } from "../../../plugins";
import { uuid } from "@/utils/uuid";

const StoangeHeader: Header[] = [
  { title: "容器名称", key: "containerName", width: 200 },
  { title: "类型", key: "type", width: 100 },
  { title: "挂载名称", key: "volumeName", width: 200 },
  { title: "挂载路径", key: "mountPath", width: 100 },
  { title: "是否只读", key: "readOnly", width: 100 },
  { title: "存储类型", key: "storageClass", width: 200 },
  { title: "容量", key: "capacity", width: 100 },
  { title: "访问模式", key: "model", width: 150 }
];

const ContainerListHeader: Header[] = [
  { title: "名称", key: "", width: 180 },
  { title: "镜像", key: "", width: 250 },
  { title: "状态", key: "", width: 220 },
  { title: "重启次数", key: "", width: 100 },
  { title: "端口", key: "", width: 100 }
];
const EnvHeader: Header[] = [
  { title: "容器名称", key: "containerName", width: 200 },
  { title: "环境变量类型", key: "envType" },
  { title: "环境变量名称", key: "name" },
  { title: "引用源配置key", key: "sourceKey" },
  { title: "引用源配置名称", key: "sourceName" },
  { title: "环境变量值", key: "value" }
];

const infoHeader: ListHeader[] = [
  { title: "容器名称", key: "metadata.name" },
  { title: "容器组IP", key: "status.podIP" },
  { title: "主机名称", key: "spec.nodeName" },
  { title: "主机IP", key: "status.hostIP" },
  { title: "容器状态分析", key: "status.conditions" }
];
export default Vue.extend({
  name: "Overview",
  props: { data: { type: Object }, projectId: { type: String } },
  data() {
    return {
      uuid: uuid(),
      StoangeHeader,
      ContainerListHeader,
      EnvHeader,
      infoHeader,
      containerData: null as any,
      envsData: [] as any[],
      storageData: [] as any[],
      cLoading: false,
      eLoading: false,
      sLoading: false
    };
  },
  mounted() {
    this.getData();
    this.getStorages();
    this.getEnvs();
  },
  computed: {
    conditions() {
      if (!this.containerData) return [];
      // @ts-ignore
      return (this.containerData.status.conditions as any[]).reverse();
    }
  },
  methods: {
    getData() {
      this.cLoading = true;
      axios
        .get(
          `/pod/detail/project?name=${this.data.metadata.name}&projectId=${this.projectId}`
        )
        .then(res => {
          this.containerData = res.data.data;
        })
        .finally(() => {
          this.cLoading = false;
        });
    },
    getStorages() {
      if (!this.data.metadata.labels["appmgr-pod-app"]) return;
      let url = "";
      if (this.data.metadata.labels["appmgr-pod-loadType"] === "Deployment") {
        url = "/deployment/";
      } else if (
        this.data.metadata.labels["appmgr-pod-loadType"] === "StatefulSet"
      ) {
        url = "/statefulset/";
      }
      this.sLoading = true;
      axios
        .get(
          `${url}${this.projectId}/${this.data.metadata.labels["appmgr-pod-app"]}/storage`
        )
        .then(res => {
          this.storageData = res.data.data;
        })
        .finally(() => {
          this.sLoading = false;
        });
    },
    getEnvs() {
      if (!this.data.metadata.labels["appmgr-pod-app"]) return;
      let url = "";
      if (this.data.metadata.labels["appmgr-pod-loadType"] === "Deployment") {
        url = "/deployment/";
      } else if (
        this.data.metadata.labels["appmgr-pod-loadType"] === "StatefulSet"
      ) {
        url = "/statefulset/";
      }
      this.eLoading = true;

      axios
        .get(
          `${url}${this.projectId}/${this.data.metadata.labels["appmgr-pod-app"]}/env`
        )
        .then(res => {
          this.envsData = res.data.data;
        })
        .finally(() => {
          this.eLoading = false;
        });
    },
    findePort(name: string) {
      const container = (this.containerData.spec.containers as any[]).find(
        item => item.name === name
      );

      if (container) {
        return container.ports as any[];
      } else {
        return [];
      }
    },
    getState(state: any) {
      if (state.waiting) {
        return `<div class="flexable"> <span class="status orange"></span>等待中</div>`;
      } else if (state.running) {
        return `<div class="flexable"> <span class="status blue"></span>运行中</div>`;
      } else if (state.terminated) {
        if (state.terminated.exitCode === 0) {
          return `<div class="flexable">
                    <span class="status green"></span>
                    <div style="flex:1 1 auto;" class="ellipsis" title="终止: ${state.terminated.reason}">终止: ${state.terminated.reason}</div>
                  </div>`;
        } else {
          return `<div class="flexable">
                    <span class="status red"></span>
                    <div style="flex:1 1 auto;">
                      <div class="ellipsis" title="终止: ${state.terminated.reason}">终止: ${state.terminated.reason}</div>
                      <div class="ellipsis" title="退出: ${state.terminated.exitCode}">退出: ${state.terminated.exitCode}</div>
                    </div>
                  </div>`;
        }
      } else {
        return `<div class="flexable"> <span class="status gray"></span>未知</div>`;
      }
    },
    getStatus(data: any) {
      if (data.state.waiting !== null) {
        return "等待中";
      }
      if (data.state.running !== null) {
        return "运行中";
      }
      if (data.state.terminated !== null) {
        if (!data.state.terminated.exitCode) {
          return "已完成";
        } else {
          return "已终止";
        }
      }
    },
    getStatusColor(data: any) {
      //
      if (data.state.waiting !== null) {
        return "yallow";
      }
      if (data.state.running !== null) {
        return "green";
      }
      if (data.state.terminated !== null) {
        if (!data.state.terminated.exitCode) {
          return "blue";
        } else {
          return "red";
        }
      }
    },
    getStatusInfo(data: any) {
      if (data.state.waiting !== null) {
        return data.state.waiting.reason;
      }
      if (data.state.running !== null) {
        return `startedAt: ${data.state.running.startedAt}`;
      }
      if (data.state.terminated !== null) {
        return data.state.terminated.reason;
      }
    }
  }
});
